import { GraphQL } from '@guestgoodie/graphql'

export function isNewFile(file: unknown): file is NewFile {
  return (
    !!file &&
    typeof file === 'object' &&
    'file' in file &&
    file.file instanceof File
  )
}

export function isDirtyFile(file: unknown): file is DirtyFile {
  return (
    !!file &&
    typeof file === 'object' &&
    !isNewFile(file) &&
    '__typename' in file &&
    file.__typename == 'File' &&
    'isDirty' in file &&
    typeof file.isDirty === 'boolean' &&
    file.isDirty
  )
}

export function isGraphqlFile(
  file: unknown
): file is GraphQL.FileFragmentFragment {
  return (
    !!file &&
    typeof file === 'object' &&
    'state' in file &&
    '__typename' in file &&
    file.__typename == 'File'
  )
}

export function isGoodieFile(obj: unknown): obj is GoodieFile {
  return isGraphqlFile(obj) || isDirtyFile(obj) || isNewFile(obj)
}

export interface NewFile {
  captions?: GraphQL.Caption[] | null
  processingMetadata?: GraphQL.ProcessingMetadata
  alwaysMute?: boolean
  altText?: string
  file: File
  translations?: GraphQL.TranslationInput[]
}

export type DirtyFile = Omit<GraphQL.FileFragmentFragment, 'translations'> & {
  isDirty: true
  translations?: (GraphQL.TranslationInput | GraphQL.Translation)[]
}

export type GoodieFile = NewFile | GraphQL.FileFragmentFragment | DirtyFile
export type ExistingFile = GraphQL.FileFragmentFragment | DirtyFile

export enum DropPositions {
  left = 'LEFT',
  right = 'RIGHT'
}
